"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSettingsContext = exports.useUserSettingsContext = exports.FilterFormContext = void 0;
const react_1 = require("react");
const userSettings = {
    timezone: "+01:00",
    // timeFormat: "YYYY-MM-DD HH:mm"
    timeFormat: "DD-MM-YYYY HH:mm"
};
const UserSettingsContext = (0, react_1.createContext)(userSettings);
exports.UserSettingsContext = UserSettingsContext;
const useUserSettingsContext = () => {
    const context = (0, react_1.useContext)(UserSettingsContext);
    if (!context) {
        throw Error("User context outside of provider");
    }
    return context;
};
exports.useUserSettingsContext = useUserSettingsContext;
const FilterFormContext = (0, react_1.createContext)({});
exports.FilterFormContext = FilterFormContext;
//# sourceMappingURL=AppContexts.js.map